import React, { useState, useEffect, useRef } from "react";
import SearchedTenders from "./SearchedTendors";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/Footer";
import waimg from "../../assets/images/whatsapp.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CounterCards from "./counterCard/counterCard";
import LogoCarousel from "./logoCarasoul/logoCarasoul";
import { Book, MapPin, Globe, Search } from "lucide-react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  IconButton,
} from "@mui/material";
import { handleAPIRequest } from "../../api/api";
import { FaEye } from "react-icons/fa";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import noImg from "../../assets/images/nia.jpg";
import useMembershipStatus from "../../useMemberShipStatus";
import { useNavigate } from "react-router-dom";
import worldMap from "../../assets/images/wm2.png";
const Homepage = () => {
  useMembershipStatus();
  const navigate = useNavigate();
  const { membershipStatus, isAuthenticated, user, role } = useSelector(
    (state) => state.auth
  );
  const [error, setError] = useState({ searchOrFilter: false });
  const [searchTerm, setSearchTerm] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isInternational, setIsInternational] = useState(0);
  const mainContentRef = useRef(null);
  const [showTenders, setShowTenders] = useState(false);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [latestTenders, setLatestTenders] = useState([]);
  const tendersPerPage = 15;

  const currentTenders = latestTenders.slice(
    (currentPage - 1) * tendersPerPage,
    currentPage * tendersPerPage
  );

  const handleRefresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    const fetchLatestTenders = async () => {
      try {
        const response = await handleAPIRequest("get", "latest-tenders", null);
        setLatestTenders(
          Array.isArray(response.tenders) ? response.tenders : []
        );
      } catch (error) {
        setLatestTenders([]);
      }
    };

    fetchLatestTenders();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await handleAPIRequest("get", "get-countries");
        if (response && response.countries) {
          const countryOptions = response.countries.map((country) => ({
            value: country.id,
            label: country.name,
          }));
          setCountries(countryOptions);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
      const getVisitors = async () => {
        try {
          const response = await handleAPIRequest("get", "get-visitor");
       
        } catch (error) {
          console.error("Error fetching visitors:", error);
        }
      }
    fetchCountries();
    getVisitors();
  }, []);

  const handleSearch = () => {
    setShowTenders(false); // Temporarily hide results to trigger re-render
    setTimeout(() => {
      setShowTenders(true); // Show updated results
    }, 0);
  };

  const handleApplyNow = (tender) => {
    if (!isAuthenticated) {
      toast.error("Please login first to view this tender.");
      return;
    }

    if (
      membershipStatus === "inactive" &&
      role !== "super_admin" &&
      role !== "admin"
    ) {
      toast.error("Please upgrade your membership to view this tender.");
      return;
    }

    navigate("/single-tender", { state: { tender } });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Navbar />

      {/* Hero Section */}
      <div className="flex flex-col items-center justify-center text-center py-20 px-6 bg-gradient-to-r from-blue-500 to-green-400 text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Dedicated platform for NGOs to publish tenders and suppliers to bid with confidence
        </h1>
        <p className="text-lg md:text-xl max-w-2xl">
        Ensuring transparency, efficiency, and fair competition in procurement.
        </p>

        <div className="w-full max-w-6xl mx-auto mt-10 px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Global Tenders */}
          <div
            className="bg-white p-6 rounded-lg shadow-lg transition-transform transform hover:-translate-y-2 hover:shadow-2xl flex flex-col items-center text-center cursor-pointer"
            onClick={() => navigate("/international-tenders")}
          >
            <Globe className="text-blue-500" size={40} />
            <h3 className="text-xl font-semibold mt-4">Global Tenders</h3>
            <p className="text-gray-600 mt-2">
              Access international procurement opportunities from around the
              world.
            </p>
          </div>

          {/* Local Tenders */}
          <div
            className="bg-white p-6 rounded-lg shadow-lg transition-transform transform hover:-translate-y-2 hover:shadow-2xl flex flex-col items-center text-center cursor-pointer"
            onClick={() => navigate("/national-tenders")}
          >
            <MapPin className="text-green-500" size={40} />
            <h3 className="text-xl font-semibold mt-4">Local Tenders</h3>
            <p className="text-gray-600 mt-2">
              Find and bid on tenders within your region or country.
            </p>
          </div>

          {/* Tender Guide */}
          <div
            className="bg-white p-6 rounded-lg shadow-lg transition-transform transform hover:-translate-y-2 hover:shadow-2xl flex flex-col items-center text-center cursor-pointer"
            onClick={() => navigate("/guide")}
          >
            <Book className="text-purple-500" size={40} />
            <h3 className="text-xl font-semibold mt-4">Tender Guide</h3>
            <p className="text-gray-600 mt-2">
              Learn how to navigate tendering processes and increase your
              chances of winning.
            </p>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="w-full max-w-7xl mx-auto mt-10 px-6 py-6 bg-white shadow-md rounded-lg flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
  {/* Search Input */}
  <TextField
    variant="outlined"
    placeholder="Search for Tenders..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="w-full md:flex-grow"
    style={{ height: "48px", minWidth: "250px" }}
    InputProps={{ style: { height: "48px", padding: "0 10px" } }}
  />

  {/* Country Select Dropdown */}
  <Select
    options={countries}
    value={countries.find((c) => c.value === selectedCountry) || null}
    onChange={(selectedOption) =>
      setSelectedCountry(selectedOption ? selectedOption.value : null)
    }
    isSearchable
    placeholder="Select a country"
    className="w-full md:w-auto"
    styles={{
      control: (base) => ({ ...base, height: "48px", minWidth: "250px" }),
    }}
  />

  {/* Filter Dropdown */}
  <FormControl variant="outlined" className="w-full md:w-1/4">
    <InputLabel id="filter-label">Filter</InputLabel>
    <MuiSelect
      labelId="filter-label"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      label="Filter"
    >
      <MenuItem value="">None</MenuItem>
      <MenuItem value="Agriculture and Livelihood Supplies">
        Agriculture and Livelihood Supplies
      </MenuItem>
      <MenuItem value="Construction and Infrastructure">
        Construction and Infrastructure
      </MenuItem>
      <MenuItem value="Information Technology (IT) and Equipment">
        Information Technology (IT) and Equipment
      </MenuItem>
      <MenuItem value="Healthcare and Medical Supplies">
        Healthcare and Medical Supplies
      </MenuItem>
      <MenuItem value="Non-Food Items (NFI)">Non-Food Items (NFI)</MenuItem>
      <MenuItem value="Food Supplies and Nutrition">
        Food Supplies and Nutrition
      </MenuItem>
      <MenuItem value="Water, Sanitation, and Hygiene (WASH)">
        Water, Sanitation, and Hygiene (WASH)
      </MenuItem>
      <MenuItem value="Education and Training Materials">
        Education and Training Materials
      </MenuItem>
      <MenuItem value="Energy and Solar Solutions">
        Energy and Solar Solutions
      </MenuItem>
      <MenuItem value="Transport and Vehicle Leasing">
        Transport and Vehicle Leasing
      </MenuItem>
      <MenuItem value="Logistics and Warehousing">
        Logistics and Warehousing
      </MenuItem>
      <MenuItem value="Consultancy and Research Services">
        Consultancy and Research Services
      </MenuItem>
      <MenuItem value="Protective Equipment and Safety Gear">
        Protective Equipment and Safety Gear
      </MenuItem>
      <MenuItem value="Communication and Media Services">
        Communication and Media Services
      </MenuItem>
      <MenuItem value="Office Supplies and Furniture">
        Office Supplies and Furniture
      </MenuItem>
    </MuiSelect>
  </FormControl>

  {/* International Checkbox */}
  <FormControlLabel
    control={
      <Checkbox
        checked={isInternational === 1}
        onChange={() => setIsInternational(isInternational === 1 ? 0 : 1)}
        color="primary"
      />
    }
    label="International"
    className="h-12 flex items-center"
  />

  {/* Search Button */}
  <Button
    variant="contained"
    color="primary"
    onClick={handleSearch}
    className="w-full md:w-auto py-3 px-6 flex items-center gap-2"
    style={{ height: "48px", minWidth: "150px" }}
  >
    <Search size={20} /> Search
  </Button>

  {/* Refresh Button */}
  <IconButton
    onClick={handleRefresh}
    color="primary"
    size="large"
    className="w-full md:w-auto"
  >
    <RefreshIcon />
  </IconButton>
</div>

      {/* Tender Cards */}
      <div ref={mainContentRef} className="w-full p-6 bg-gray-100">
  <h2 className="text-2xl md:text-3xl font-bold text-blue-500 text-center mt-5 mb-5">
    {showTenders ? "SEARCHED RESULTS" : "LATEST TENDERS"}
  </h2>

        {showTenders ? (
          <SearchedTenders
            searchTerm={searchTerm}
            filter={filter}
            selectedCountry={selectedCountry}
            isInternational={isInternational}
          />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 w-full max-w-7xl mx-auto">
            {currentTenders.slice(0, 10).map((tender) => (
              <div
                key={tender.id}
                className="bg-white flex flex-col p-3 rounded-lg shadow-md border hover:shadow-lg transition-all"
              >
                <img
                  src={tender?.company_document?.document_url || noImg}
                  alt={tender.tender_title}
                  className="w-full h-28 object-contain rounded-md"
                />
                <div className="flex-grow flex flex-col justify-between mt-2">
                  <h3 className="text-sm font-bold text-gray-800">
                    {tender.tender_title}
                  </h3>
                  <div className="flex flex-wrap gap-1 my-1">
                    <span className="text-xs text-white bg-green-500 px-2 py-1 rounded-md">
                      Start:{" "}
                      {dayjs(tender.tender_start_date).format("DD MMM YYYY")}
                    </span>
                    <span className="text-xs text-white bg-red-500 px-2 py-1 rounded-md">
                      End: {dayjs(tender.tender_end_date).format("DD MMM YYYY")}
                    </span>
                    <span className="text-xs text-white bg-purple-500 px-2 py-1 rounded-md">
                      {tender.companies.company_name}
                    </span>
                    <span className="text-xs px-2 py-1 rounded-md bg-gray-500 text-white">
                      {tender.bid_method === "Online"
                        ? "Online Bid"
                        : "Manual Bid"}
                    </span>
                  </div>
                  <button
                    onClick={() => handleApplyNow(tender)}
                    className="mt-1 text-blue-600 hover:text-blue-700 self-end"
                  >
                    <FaEye size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
          <div className="flex justify-end gap-3 mt-8 mb-5" style={{ marginRight:'174px' }}>
    <button
      onClick={() => navigate("/international-tenders")}
      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition w-full md:w-auto"
    >
      View All International Tenders
    </button>
    <button
      onClick={() => navigate("/national-tenders")}
      className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition w-full md:w-auto"
    >
      View All Tenders in Pakistan
    </button>
  </div>
      </div>

      <div className="rounded-lg overflow-hidden p-6 flex flex-col md:flex-row items-center">
        {/* World Map Image */}
        <div className="w-full md:w-1/2">
          <img
            src={worldMap}
            alt="World Map"
            className="w-full h-auto rounded-md"
          />
        </div>

        {/* Text Content */}
        <div className="w-full md:w-1/2 md:pl-6 mt-4 md:mt-0">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Global NGO Tenders & Procurement Opportunities
          </h2>
          <p className="text-gray-600">
            Discover global NGO tenders and procurement opportunities in Asia,
            Africa, Europe, and the Americas. Our simple platform connects you
            with local and international tenders that fuel your mission. Access
            government and private tenders that bring in vital funding and
            contracts. We make the tender process easy so you can win global
            opportunities and grants. Join our worldwide tender network and
            boost your cause with endless funding possibilities.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Powering Global Tenders
          </h2>
          <p className="text-gray-600">
            Bilcono Bilcono is the expert behind our global tender solutions,
            revolutionizing the way NGOs access active tenders and procurement
            opportunities. We simplify the tender process, connecting NGOs with
            international funding, government contracts, and private tenders
            that drive mission success. With our advanced platform, Bilcono
            opens doors to valuable active tender opportunities worldwide. Trust
            us to bridge the gap between NGOs and crucial procurement solutions,
            helping you secure funding and contracts where they matter most.
          </p>
        </div>
      </div>

      <CounterCards />
      <LogoCarousel />
      <Footer />

      <a
        href="https://wa.me/+923121111002"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 bg-green-500 p-3 rounded-full shadow-lg"
      >
        <img src={waimg} alt="Chat with us" className="w-12 h-12" />
      </a>

      <ToastContainer />
    </div>
  );
};

export default Homepage;
